import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CollegeRecrutingCenterService {
  private _apiUrl = '/api/CollegeRecruitingCenter';
  private _apiUrlTeam = '/api/Team';
  private _apiUrlEvent = '/api/Event';
  private _apiUrlPlayer = '/api/Player';
  private _apiUrlStripe = '/api/Stripe';
  private _api = '/api/club';
  links: { title: string; url: any; }[];

  constructor(private _http: HttpService, private _httpClient: HttpClient) { }

  getCollegeRecruitingCenterData(clubId: number) {
    return this._http.get(this._apiUrl + `/get-all-college-recruiting-center-data-club-id/${clubId}`);
  }

  checkClubIsRegisteredToCollegeRecruitingPlan(clubId: number) {
    return this._http.get(this._apiUrl + `/check-club-is-registered-to-college-recruiting-plan/${clubId}`);
  }

  getClubCollegeRecruitingPlans() {
    return this._http.get(this._apiUrl + `/get-club-college-recruiting-plans/`);
  }

  validateDiscountCode(discountCode: string, originalAmount: number) {
    return this._http.get(this._apiUrlPlayer + '/validate-discount-code/' + discountCode + '/' + originalAmount);
  }

  registerClubToCollegeProductPlan(planObj: any) {
    return this._httpClient.post(this._apiUrl + '/register-club-to-college-product-plan', planObj);
  }

  updateClubTeamPlayerSubscriptionLevel(data: any) {
    return this._httpClient.post(this._apiUrlStripe + '/update-club-team-player-subscription-level', data);
  }

  cancelOrRenewSusbscriptionPlan(data: any) {
    return this._httpClient.post(this._apiUrl + '/cancel-or-renew-subscription-plan', data);
  }

  getSearchedColleges(searchInfo: any) {
    //const httpOptions = {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'application/json',
    //    'responseType': 'text'
    //  })
    //};
    //return this._http.post(this._apiUrlPlayer + '/get-college-list-by-search', searchInfo, httpOptions);

    return this._httpClient.post(this._apiUrl + '/get-user-college-search-list-for-club', searchInfo);
  }

  getCollegeViewsCountsAndMessagesSendCounts(clubID: number, collegeProgramID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-college-message-count/' + clubID + '/' + collegeProgramID + '/' + teamID);
  }
  getAllEventList(eventID: number) {
    return this._http.get(this._apiUrlEvent + '/get-all-event-list/' + eventID);
  }

  getCollegeDetails(collegeID: number, collegeProgramID: number) {
    return this._http.get(this._apiUrl + '/get-college-data-by-ID/' + collegeID + '/' + collegeProgramID);
  }

  getCollegeCampList(collegeID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-college-camp-data/' + collegeID);
  }

  getCollegeDivisionList() {
    return this._http.get(this._apiUrlPlayer + '/get-college-division-list');
  }

  getCollegeStaffList(collegeProgramID: number, collegeID: number) {
    return this._httpClient.get(this._apiUrlPlayer + '/get-college-staff-list/' + collegeProgramID + '/' + collegeID);
  }

  getUserDetails(userID: number) {
    return this._httpClient.get('/api/ClubMember/getUser/' + userID);
  }

  getPlayerAttendingThisCollegeData(clubID: number, collegeID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-player-college-attending-data/' + clubID + '/' + collegeID + '/' + teamID);
  }

  getCollegeLeftNavCounts(clubID: number, collegeID: number, collegeProgramID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-college-dashboard-left-nav-counts/' + clubID + '/' + collegeID + '/' + collegeProgramID + '/' + teamID);
  }

  getCollegeConferenceList() {
    return this._http.get(this._apiUrlPlayer + '/get-college-conference-list');
  }

  getCollegeViewData(clubID: number, collegeID: number, collegeProgramID: number, teamID: number) {
    return this._http.get(this._apiUrl + '/get-college-view-data-with-count/' + clubID + '/' + collegeID + '/' + collegeProgramID + '/' + teamID)
  }

  getPlayerFavoriteDate(clubID: number, collegeID: number, collegeProgramID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-player-favorites-data/' + clubID + '/' + collegeID + '/' + collegeProgramID + '/' + teamID)
  }

  getPlayerCollegeFavoriteList(playerID: number) {
    return this._httpClient.get(this._apiUrlTeam + '/get-player-college-favorite-list/' + playerID);
  }

  getClubPlayerCollegeFavoriteData(clubID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-player-college-favorites-data/' + clubID + '/' + teamID);
  }

  getSchoolSummary(collegeID: number, gender: string, playerID: number) {
    return this._httpClient.get(this._apiUrlPlayer + '/get-college-details/' + collegeID + '/' + gender + '/' + playerID);
  }

  getCampOverview(campID: number, playerID: number) {
    return this._httpClient.get(this._apiUrlPlayer + '/get-college-camp-details/' + campID + '/' + playerID);
  }

  getPlayerAttendedCampCount(campID: number) {
    return this._httpClient.get(this._apiUrl + '/get-registered-players-for-camp/' + campID);
  }

  getClubEventDivisionListPercentage(clubID: number, eventID: number) {
    return this._httpClient.get<any>(this._apiUrl + '/get-club-event-college-attendance-division-percentage/' + clubID + '/' + eventID);
  }

  getClubEventCollegeAttendanceDivisionPercentage(clubID: number, eventID: number) {
    return this._httpClient.get<any>(this._apiUrl + '/get-club-event-college-attendance-division-percentage/' + clubID + '/' + eventID);
  }

  getDivisionListPercentage(clubID: number, eventID: number, teamID: number, matchID: number) {
    return this._httpClient.get<any>(this._apiUrl + '/get-club-college-attendance-division-percentage/' + clubID + '/' + eventID + '/' + teamID + '/' + matchID);
  }

  getCollegeComminicationDivisionCount(clubID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-college-communication-division-percentage-top-counts/' + clubID + '/' + teamID);
  }

  getIndividualEventList(playerID: number) {
    return this._httpClient.get<any>(this._apiUrlPlayer + '/get-game-history-event/' + playerID);
  }

  getClubEventListWithAttendedCounts(clubID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-event-list-with-attended-counts/' + clubID + '/' + teamID);
  }

  getCommunicationDetails(clubID: number, teamID: number, collegeProgramID: number) {
    return this._httpClient.get(this._apiUrl + '/get-communication-data/' + clubID + '/' + teamID + '/' + collegeProgramID);
  }

  getClubCollegePlayerDetails(clubID: number, flag: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-college-players-with-top-counts/' + clubID + '/' + flag);
  }

  getPlayerListForTeamOrClub(clubID: number, teamID: number, flag: number) {
    return this._httpClient.get(this._apiUrl + '/get-players-list-for-team-or-club/' + clubID + '/' + teamID + '/' + flag);
  }

  getClubPlayerUnfavoriteCollegesList(clubID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-player-Unfavorites-data/' + clubID + '/' + teamID);
  }

  getCollegetCommimentDataList(clubID: number, flag: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-college-commitments/' + clubID + '/' + flag);
  }

  getEventDetailsByEventID(eventID: number) {
    return this._httpClient.get(this._apiUrlEvent + '/get-event-details-by-eventID/' + eventID);
  }

  checkSidelineDocumentDownloadHistoryAvailable(eventID: number, teamID: number, matchID: number) {
    return this._httpClient.get(this._apiUrlEvent + '/check-sideline-document-download-history-available/' + eventID + '/' + teamID + '/' + matchID);
  }

  getClubGameInfoWithCounts(clubId: number, eventID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-game-info-with-counts/' + clubId + '/' + eventID + '/' + teamID);
  }

  getIndividualEventsExportData(clubId: number, eventID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-individual-events-export-data/' + clubId + '/' + eventID + '/' + teamID);
  }

  exportCollegeEventGamesData(clubId: number, eventID: number, teamID: number, selectedGames: string) {
    return this._http.get(this._apiUrl + '/get-export-college-event-games-data/' + clubId + '/' + eventID + '/' + teamID + '/' + selectedGames);
  }
  //get-export-college-event-games-Details/{userID}/{eventID}/{teamID}/{matchID}
  getExportCollegeEventGamesDetails(userID: number, eventID: number, teamID: number, matchID: number) {
    return this._http.get(this._apiUrlEvent + '/get-export-college-event-games-Details/' + userID + '/' + eventID + '/' + teamID + '/' + matchID);
  }
  getSidelineCheckInDocumentPlan() {
    return this._http.get(this._apiUrlEvent + '/get-sideline-check-in-document-plan');
  }

  getTeamMatchListCount(teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-team-match-list/' + teamID);
  }

  getClubCollegeGameAttendanceDetail(clubID: number, eventID: number, matchID: number, teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-college-game-attendance-detail/' + clubID + '/' + eventID + '/' + matchID + '/' + teamID);
  }

  getClubCollegeGameAttendanceDetailforTeams(teamID: number, matchID: number, gameType: number) {
    if (gameType == 1) {
      return this._httpClient.get(this._apiUrl + '/get-club-college-game-attendance-detail-for-teams/' + teamID + '/' + matchID);
    }
    else {
      return this._httpClient.get(this._apiUrl + '/get-college-game-attendance-detail-for-non-tgs/' + '/' + matchID + '/' + teamID);
    }
  }

  getClubCollegeGameAttendanceDetailforTeamsExportData(teamID: number, selectedGames: string) {
    return this._httpClient.get(this._apiUrl + '/get-club-college-game-attendance-detail-for-teams-export-data/' + teamID + '/' + selectedGames);
  }

  getCollegeAttendanceExportForTgsAndNonTgsGames(obj: any) {
    return this._httpClient.post(this._apiUrl + '/get-college-attendance-export-for-tgs-and-non-tgs-games/', obj);
  }

  getCollegeListByStateAndGender(stateID: number, matchID: number) {
    return this._httpClient.get(this._apiUrl + '/get-college-list-by-state-and-gender/' + stateID + '/' + matchID);
  }

  getCollegeListByStateAndType(obj: any) {
    return this._httpClient.post(this._apiUrl + '/get-college-list-by-state-and-type', obj);
  }

  getCollegeStaffListByState(matchID: number, teamID: number, collegeProgramID: number, gameType: number) {
    return this._httpClient.get(this._apiUrl + '/get-college-staff-list-new/' + matchID + '/' + teamID + '/' + collegeProgramID + '/' + gameType);
  }

  saveAndUpdateCoachCollegeAttendingDetails(matchID: number, teamID: number, collegeProgramID: number, gameType: number, staffIDList: number[]) {
    return this._httpClient.post(this._apiUrl + '/save-or-update-coach-college-attending-new/' + matchID + '/' + teamID + '/' + collegeProgramID + '/' + gameType, staffIDList);
  }

  sendEmailOfUncommittedListToCollege(mailObject: any) {
    return this._httpClient.post(this._apiUrl + '/send-uncommitted-list-to-college/', mailObject);
  }

  sendUncommittedListToCollegeCoachByEvent(payload: any) {
    return this._httpClient.post(this._apiUrl + '/send-uncommitted-list-to-college-coach-by-event/', payload);
  }

  getAllStates() {
    return this._httpClient.get('/api/Association/get-all-states');
  }

  getClubTeamListWithCount(clubID: number) {
    return this._httpClient.get(this._apiUrl + '/get-club-team-list-with-attended-counts/' + clubID);
  }

  getCommunicationStaffMessageCountDetails(playerID: number) {
    return this._httpClient.get(this._apiUrl + '/get-college-communication-By-Player/' + playerID);
  }

  getTeamUnCommittedPlayerList(teamID: number) {
    return this._httpClient.get(this._apiUrl + '/get-team-uncommitted-player-list/' + teamID);
  }

  getEventDetailsByTeamPamphlet(teamID: number) {
    return this._httpClient.get(this._apiUrlTeam + '/get-events-for-team-pemphlet/' + teamID);
  }

  onClickNotifyService() {
    return this._http.get(
      this._apiUrl + `/on-click-notify-example`
    );
  }

  /* Subscription Plans [Club and Team] */
  getClubTeamSubscriptionPlansWithPlanName(clubID: number, teamID: number) {
    return this._http.get(this._apiUrl + `/get-club-team-subscription-plans-with-plan-name/` + clubID + `/` + teamID);
  }

  updateClubStripeSubscriptionExpirationDates(clubID: number, productTypeID: number) {
    return this._http.post(this._apiUrlStripe + `/update-club-stripe-subscriptions-expire-dates/` + clubID + `/` + productTypeID);
  }

  /* Evaluations */
  getClubEvaluationsPlans() {
    return this._http.get(this._apiUrl + `/get-club-evaluations-plans/`);
  }

  getClubSubscriptionPlans(clubID: number) {
    return this._http.get(this._apiUrl + `/get-club-subscription-plans/` + clubID);
  }

  getCardDetailsByStripeSubscriptionID(stripeSubscriptionID: string, clubID: number, productTypeID: number) {
    return this._http.get(this._apiUrl + `/get-card-details-by-stripesubscriptionID/` + stripeSubscriptionID + '/' + clubID + '/' + productTypeID);
  }

  getTeamSubscriptionPlans(teamID: number) {
    return this._http.get(this._apiUrl + `/get-team-subscription-plans/` + teamID);
  }

  registerClubTeamToProductPlanSubscription(planObj: any) {
    return this._httpClient.post(this._apiUrl + '/register-club-team-to-product-plan-subscription', planObj);
  }

  generatePDFAfterRegisterClubToCollegeProductPlan(clubSubscriptionID, planObj: any) {
    return this._httpClient.post(this._apiUrl + '/generate-pdf-after-registration-of-club-to-college-product-plan/' + clubSubscriptionID, planObj);
  }

  /* club - video */
  getClubVideoPlans() {
    return this._http.get(this._apiUrl + `/get-club-video-plans/`);
  }
  /* Health And Fitness */
  getClubHealthAndFitnessPlans() {
    return this._http.get(this._apiUrl + `/get-club-health-and-fitness-plans/`);
  }
  /* Communication Center Email Campaign */
  getClubEmailCampaignPlans() {
    return this._http.get(this._apiUrl + `/get-club-email-campaign-plans/`);
  }
  /* Communication Center Mobile App */
  getClubMobileAppPlans(clubID: number) {
    return this._http.get(this._apiUrl + `/get-club-mobile-app-plans-by-clubID/` + clubID);
  }

  getSubscriptionTransactionHistory(planObj: any) {
    return this._http.get(this._apiUrl + `/get-subscription-transaction-history/` + planObj.teamID + "/" + planObj.clubID + "/" + planObj.productTypeID);
  }
  getClubSubscriptionPlanList(clubID: number, teamID: number) {
    if (teamID > 0) {
      return this._http.get(this._apiUrl + `/get-team-subscription-plan-list/` + teamID);
    }
    return this._http.get(this._apiUrl + `/get-club-subscription-plan-list/` + clubID);
  }
  getClubTeamProductPlansByProductTypeID(obj: any) {
    return this._http.get(this._apiUrl + `/get-club-team-product-plans-by-product-type/` + obj.productTypeID + "/" + obj.clubID + "/" + obj.teamID);
  }

  getEventStaffThatCheckIn(clubID: number, teamID: number, collegeID: number) {
    return this._http.get(this._apiUrl + `/get-event-history-by-club-or-team/` + clubID + `/` + teamID + `/` + collegeID);
  }
  getAllClubList() {
    return this._http.get(this._api + '/get-all-club-list');
  }

  updateCardDetailsByStripeSubscriptionID(obj: any) {
    return this._httpClient.post(this._apiUrl + '/update-card-details-by-stripeSubscriptionID', obj);
  }

  createEventTeamSideLineDocumentPaymentForTeamAccount(payload: any) {
    return this._httpClient.post(this._apiUrlEvent + '/create-event-team-sideline-document-payment-for-team-account', payload);
  }
  getSidelineCheckInCodeDataByTeamID(teamID: number) {
    return this._http.get(this._apiUrlTeam + '/get-sideline-check-in-code-data-by-teamID/' + teamID);
  }
  addOrUpdateSidelineCheckInData(payload: any) {
    return this._httpClient.post(this._apiUrlTeam + '/add-or-update-sideline-check-in-code-data-by-team', payload);
  }
  removeSideLineCode(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        SidelineCodeIDList: payload.SidelineCodeIDList
      }
    };
    return this._http.delete(this._apiUrlTeam + '/remove-sideline-check-in-code', httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/college-recruiting-center.service.ts